<script>
import FadeTransition from '@src/components/Transitions/Fade.vue';
import { h } from 'vue';
import SbLoadingSpinner from '@src/components/Loading/SbLoadingSpinner.vue';

export default {
  name: 'SbLoadingPromiseWrapper',
  props: {
    /**
     * A promise which will be used to apply loading styles until its resolved/rejected
     */
    loadingPromise: {
      type: Promise,
      default: null,
    },
    /**
     * loading state which will be synced
     */
    loading: {
      type: Boolean,
      default: undefined,
    },
    /**
     * Size of the loading spinner
     */
    size: {
      type: String,
      default: 'sm',
      validator: (value) => value.match(/(xtsm|sm|md|lg)/),
    },
    /**
     * should the loader be full screen or not
     */
    fullScreen: {
      type: Boolean,
      default: false,
    },
    /**
     * classes to be applied to the wrapper element
     */
    classes: {
      type: Array,
      default: () => [],
    },
    /**
     * the threshold after which the loading style would be applied
     */
    threshold: {
      type: Number,
      default: 500,
    },
  },
  emits: [
    /**
     * Emitted every time the loading state changes
     */
    'update:loading',
  ],
  data: () => ({
    internalloadingState: false,
  }),
  watch: {
    loadingPromise: {
      immediate: true,
      handler(promise) {
        if (promise && promise.constructor.name === 'Promise') {
          const timeoutId = setTimeout(() => {
            this.setLoadingValue(true);
          }, this.threshold);

          const context = this;
          promise.finally(() => {
            clearTimeout(timeoutId);
            context.setLoadingValue(false);
          });
        }
      },
    },
  },
  methods: {
    setLoadingValue(loading) {
      this.internalloadingState = loading;
      if (loading !== undefined) {
        this.$emit('update:loading', loading);
      }
    },
  },
  render() {
    const showLoading = this.$data.internalloadingState;
    const attrs = this.$attrs;
    const { classes } = this.$props;
    const data = { attrs, class: classes };
    const slots = this.$slots.default();

    const loaderTemplate = h(
      SbLoadingSpinner,
      { size: this.$props.size, fullScreen: this.$props.fullScreen },
    );
    const fadeChildren = showLoading ? [loaderTemplate] : [];
    const fadeTemplate = h(FadeTransition, {}, () => fadeChildren);
    const templateChildren = slots ? [...slots, fadeTemplate] : [fadeTemplate];

    const template = h('div', { ...data.attrs, class: data.class, 'data-sb-regression': 'sb-loading-promise-wrapper' }, templateChildren);

    return template;
  },
};
</script>
